"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _timeout = require("../../hooks/timeout");

var _icons = require("../../icons");

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Alerts
 *
 * ## When to use
 * Alerts are used for various reasons including: response to an action, states of the page/content, or warnings and errors.
 * Alerts are useful when important information needs to be conveyed to the user and you want to grab his/her attention.
 * Use alerts only when appropriate so that users do not become desensitized to them.
 *
 * ## Style
 * Alerts are 70px height as the standard but can be adjusted. Alerts may be dismissable with a small "X" on the far right of the banner.
 * Alert color should reflect the condition in which they are appearing (i.e. red for error, green for success, orange for warning).
 *
 * @since 2.9.0
 */
var Alert = function Alert(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      children = _ref.children,
      _ref$hasDismissButton = _ref.hasDismissButton,
      hasDismissButton = _ref$hasDismissButton === void 0 ? false : _ref$hasDismissButton,
      _ref$onDismiss = _ref.onDismiss,
      onDismiss = _ref$onDismiss === void 0 ? function () {} : _ref$onDismiss,
      autoDismissMs = _ref.autoDismissMs,
      _ref$hasShadow = _ref.hasShadow,
      hasShadow = _ref$hasShadow === void 0 ? false : _ref$hasShadow,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["classes", "children", "hasDismissButton", "onDismiss", "autoDismissMs", "hasShadow", "type"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTransitionedIn = _useState2[0],
      setIsTransitionedIn = _useState2[1];

  var transitionOut = function transitionOut() {
    setIsTransitionedIn(false);
    var id = window.setTimeout(function () {
      onDismiss();
    }, 300);
    return function () {
      return clearTimeout(id);
    };
  };

  (0, _timeout.useTimeout)(function () {
    setIsTransitionedIn(true);
  }, 300);
  (0, _timeout.useTimeout)(transitionOut, autoDismissMs);
  return _react["default"].createElement("div", _extends({
    className: (0, _classnames2["default"])(classes.root, _defineProperty({}, classes.hidden, !isTransitionedIn))
  }, props), _react["default"].createElement("div", {
    className: classes.contentWrapper
  }, isTransitionedIn && children), isTransitionedIn && hasDismissButton && _react["default"].createElement("div", {
    className: classes.closeIconWrapper
  }, _react["default"].createElement(_icons.Delete, {
    height: "12px",
    width: "12px",
    onClick: transitionOut
  })));
};

Alert.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string.isRequired).isRequired,

  /** Children of Badge component */
  children: _propTypes["default"].node,

  /** Alert can be of 3 types - 'error', 'warning', 'success'. Affects the background color of the Alert */
  type: _propTypes["default"].oneOf(['success', 'warning', 'error']),

  /**
   * How long until the Alert should call `onDismiss` in milliseconds.
   * If not set, Alert will only call `onDimiss` if a user clicks on the dismiss button.
   */
  autoDismissMs: _propTypes["default"].number,

  /** `boolean` flag to show/hide the "dismiss alert" button */
  hasDismissButton: _propTypes["default"].bool,

  /** Show a shadow around the alert box. Useful for light alerts on light backgrounds */
  hasShadow: _propTypes["default"].bool,

  /** Callback fired when the Alert is closed, either by clicking the "dismiss alert" button or after the specified time has elapsed */
  onDismiss: _propTypes["default"].func
};

var _default = (0, _withStyles["default"])(_styles["default"])(Alert);

exports["default"] = _default;